import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37b007da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nr-l-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Recorded packets", -1))
const _hoisted_3 = { class: "nr-l-checkbox" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Use latest 10 minutes", -1))
const _hoisted_5 = {
  key: 0,
  class: "nr-l-range"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "p-inputgroup" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Download")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("label", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.useLatestWindow) = $event)),
        type: "checkbox"
      }, null, 512), [
        [_vModelCheckbox, _ctx.useLatestWindow]
      ]),
      _hoisted_4
    ]),
    (!_ctx.useLatestWindow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startDate) = $event)),
            type: "datetime-local"
          }, null, 512), [
            [_vModelText, _ctx.startDate]
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.endDate) = $event)),
            type: "datetime-local"
          }, null, 512), [
            [_vModelText, _ctx.endDate]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.useLatestWindow)
      ? (_openBlock(), _createElementBlock("small", _hoisted_6, "Downloads from now minus 10 minutes up to now."))
      : (_openBlock(), _createElementBlock("small", _hoisted_7, "Maximum export window: 10 minutes")),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_Button, {
        loading: _ctx.loading,
        onClick: _withModifiers(_ctx.downloadRecording, ["stop"])
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ])
  ]))
}